import React from "react";

import { Select } from "antd";
import { HelperText } from "../elements/HelperText";
import { Stack } from "@mui/material";
import { FormLabel } from "../elements/FormLabel";

const handleChange = (value) => {
  console.log(`selected ${value}`);
  // values.parent = event.target.value;
};

export const GenericSelect = ({
  placeholder,
  label,
  options,
  helperText,
  mode,
  value,
  required = false,
  optional = false,
  onChange,
  onSelect,
  info,
  disabled,
}) => (
  <Stack spacing={1}>
    <FormLabel optional={optional} required={required} info={info}>
      {label}
    </FormLabel>

    <Select
      mode={mode}
      allowClear
      style={{
        width: "100%",
      }}
      placeholder={`Select ${placeholder || label}`}
      // defaultValue={value}
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      options={options}
      showSearch
      disabled={disabled}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
    <HelperText text={helperText} />
  </Stack>
);
